import request from '@/utils/request'


export function getEducationResults(param, isNotify) {
  return request({
    url: `/api/getEducationResults`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
} 
export function getEducationPeople (param, isNotify) {
  return request({
    url: `/api/getEducationPeople`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
} 
export function getEducationStatus (param, isNotify) {
  return request({
    url: `/api/getEducationStatus`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
} 

export function getRptEducationResults (params) {
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url: '/api/getRptEducationResults',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType
  })
}

export function getRptEducationStatus (params) {
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url: '/api/getRptEducationStatus',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType
  })
}


export function signEducationPlan (param, isNotify) {
  return request({
    url: `/api/m/signEducationPlan`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
} 